export default function initMediaCarousel(Swiper, Pagination) {
    // ==========================================================
    // MEDIA
    // ==========================================================
    const mediaCarousels = document.querySelectorAll("[data-media-carousel]");

    mediaCarousels.forEach((slider) => {
        const pagination = slider.closest(".media-carousel")?.querySelector(".media-carousel__pagination");

        const slides = slider.querySelectorAll(".swiper-slide");

        if (!slides.length) {
            return;
        }

        new Swiper(slider, {
            modules: [Pagination],

            centeredSlides: true,
            loop: slides.length > 2,
            speed: 650,

            slidesPerView: 1.15,
            spaceBetween: 16,

            grabCursor: true,

            pagination: pagination
                ? {
                      el: pagination,
                      clickable: true,
                  }
                : false,

            breakpoints: {
                640: {
                    slidesPerView: 1.35,
                    spaceBetween: 20,
                },

                768: {
                    slidesPerView: 1.55,
                    spaceBetween: 24,
                },

                1024: {
                    slidesPerView: 1.8,
                    spaceBetween: 32,
                },

                1280: {
                    slidesPerView: 2.05,
                    spaceBetween: 32,
                },
            },
        });
    });
}